/* Dawn Wishlist (guest) - localStorage
   Stores: array of product handles
*/

(function () {
  const STORAGE_KEY = "mm_wishlist_handles_v1";

  function readList() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      const arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr : [];
    } catch (e) {
      return [];
    }
  }

  function writeList(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    window.dispatchEvent(new CustomEvent("wishlist:updated", { detail: { list } }));
  }

  function has(handle) {
    return readList().includes(handle);
  }

  function add(handle) {
    if (!handle) return;
    const list = readList();
    if (!list.includes(handle)) {
      list.push(handle);
      writeList(list);
    }
  }

  function remove(handle) {
    if (!handle) return;
    const list = readList().filter((h) => h !== handle);
    writeList(list);
  }

  function toggle(handle) {
    if (!handle) return;
    has(handle) ? remove(handle) : add(handle);
  }

  function clearAll() {
    writeList([]);
  }

  function setButtonState(btn, inList) {
    btn.setAttribute("aria-pressed", inList ? "true" : "false");
    btn.classList.toggle("is-active", inList);
    btn.title = inList ? "Remove from wishlist" : "Add to wishlist";
  }

  function initButtons(root = document) {
    const buttons = root.querySelectorAll("[data-wishlist-button][data-product-handle]");
    const list = readList();

    buttons.forEach((btn) => {
      const handle = btn.getAttribute("data-product-handle");
      setButtonState(btn, list.includes(handle));

      if (!btn.__wishlistBound) {
        btn.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();

          const wasInList = has(handle);
          toggle(handle);

          // Animate only when adding (not when removing)
          if (!wasInList) {
            flyHeartToHeader(btn);
          }
        });
        btn.__wishlistBound = true;
      }
    });
  }

  function updateHeaderWishlist() {
    const link = document.querySelector("[data-header-wishlist-link]");
    if (!link) return;

    const count = readList().length;
    link.classList.toggle("is-active", count > 0);
  }

  function flyHeartToHeader(fromBtn) {
    const target = document.querySelector("[data-header-wishlist-link]");
    if (!target || !fromBtn) return;

    const fromRect = fromBtn.getBoundingClientRect();
    const toRect = target.getBoundingClientRect();

    const startX = fromRect.left + fromRect.width / 2;
    const startY = fromRect.top + fromRect.height / 2;

    const endX = toRect.left + toRect.width / 2;
    const endY = toRect.top + toRect.height / 2;

    const el = document.createElement("div");
    el.className = "mm-fly-heart";
    el.style.transform = `translate(${startX}px, ${startY}px) translate(-50%, -50%)`;
    el.style.opacity = "1";

    // Heart icon (same shape)
    el.innerHTML = `
      <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path d="M12 21s-7.2-4.5-9.6-8.4C.7 9.7 2 6.5 5 5.5c1.8-.6 3.8.1 5 1.6 1.2-1.5 3.2-2.2 5-1.6 3 1 4.3 4.2 2.6 7.1C19.2 16.5 12 21 12 21z" fill="currentColor"></path>
      </svg>
    `;

    document.body.appendChild(el);

    const dx = endX - startX;
    const dy = endY - startY;

    // 1s, accelerating motion (ease-in)
    const anim = el.animate(
      [
        { transform: `translate(${startX}px, ${startY}px) translate(-50%, -50%) scale(1)`, opacity: 1 },
        { transform: `translate(${startX + dx}px, ${startY + dy}px) translate(-50%, -50%) scale(0.4)`, opacity: 0.9 }
      ],
      {
        duration: 1000,
        easing: "cubic-bezier(0.42, 0, 1, 1)", // ease-in (accelerating)
        fill: "forwards"
      }
    );

    anim.onfinish = () => {
      el.remove();
      // Small pulse on header icon for feedback
      target.animate(
        [{ transform: "scale(1)" }, { transform: "scale(1.12)" }, { transform: "scale(1)" }],
        { duration: 220, easing: "ease-out" }
      );
    };
  }

  async function fetchCardHTML(handle) {
    const res = await fetch(`/products/${encodeURIComponent(handle)}?view=wishlist-card`, {
      credentials: "same-origin",
    });
    if (!res.ok) return null;

    const html = await res.text();

    return `
      <li class="grid__item">
        ${html}
      </li>
    `;
  }

  async function renderWishlistPage() {
    const grid = document.querySelector("[data-wishlist-grid]");
    if (!grid) return; // not on wishlist page

    const emptyEl = document.querySelector("[data-wishlist-empty]");
    const clearBtn = document.querySelector("[data-wishlist-clear]");

    async function redraw() {
      const list = readList();

      if (clearBtn && !clearBtn.__bound) {
        clearBtn.addEventListener("click", () => clearAll());
        clearBtn.__bound = true;
      }

      if (!list.length) {
        grid.innerHTML = "";
        if (emptyEl) emptyEl.hidden = false;
        return;
      }

      if (emptyEl) emptyEl.hidden = true;

      grid.innerHTML = `<div class="wishlist-loading">Loading…</div>`;

      const htmlParts = [];
      for (const handle of list) {
        try {
          const card = await fetchCardHTML(handle);
          if (card) htmlParts.push(card);
        } catch (e) {}
      }

      grid.innerHTML = htmlParts.join("") || "";
      initButtons(grid);
    }

    // Keep a single listener for the wishlist page lifecycle
    if (!window.__mmWishlistPageListener) {
      window.addEventListener("wishlist:updated", () => {
        redraw();
        initButtons(document);
        updateHeaderWishlist();
      });
      window.__mmWishlistPageListener = true;
    }

    redraw();
  }

  // Expose minimal API for debug
  window.MM_WISHLIST = { readList, add, remove, toggle, clearAll, has };

  document.addEventListener("DOMContentLoaded", () => {
    initButtons(document);
    renderWishlistPage();
    updateHeaderWishlist();
  });

  // If theme loads sections dynamically (Theme Editor)
  document.addEventListener("shopify:section:load", (e) => {
    initButtons(e.target);
    updateHeaderWishlist();
  });

  // Global updates (for pages without the wishlist grid)
  window.addEventListener("wishlist:updated", () => {
    initButtons(document);
    updateHeaderWishlist();
  });
})();